import axios from "axios";
import axiosRetry from 'axios-retry';
import {config} from '../config';
import authUtility from "./AuthUtilities";

const axiosInstance = axios.create({ baseURL: config.baseUrl, timeout: config.timeout, });

axiosRetry(axiosInstance, {
    retries: config.retryCount,
    retryDelay: (retryCount) => {
        console.log(`retry attempt: ${retryCount}`);
        return retryCount * config.retryDelay;
    }
  });
  axiosInstance.interceptors.request.use(
    function (config) {
      return authUtility.addAuthorizedHeader(config, true);
    },
      function (error: unknown) {
      return Promise.reject(error);
    }
  );
  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.status === 401) {
       return authUtility.handleLogout().then(() => response);
      }
      return response;
    },
    (err: unknown) => {
         return Promise.reject(err); 
    }
  );

export default axiosInstance;
